<template>
  <div>
    <PhoneVerification ref="PhoneVerificationRef" :priceNum="price" :account="account" :isShow="isShow" types="1"
      @AccountCenter="AccountCenterFun" @closeDialog="closeDialogChange"></PhoneVerification>
    <div v-if="noMessage">
      <div>
        <div class="flex-item">
          <div class="flex-item-wrap">可用余额</div>
          <div class="flex-item-wrap" style="width: auto;">
            <span class="money">{{ max_withdraw_amount }}</span>
            <span>元</span>
            <div class="refresh" @click="refreshAccount">
              <Icon type="md-refresh" size="24" color="#999" width="24" height="24" />
              <span class="refresh-text">刷新</span>
            </div>
          </div>
        </div>
        <div class="flex-item">
          <div class="flex-item-wrap">提现金额</div>
          <el-input ref="priceNumRef" v-model="price" type="number" placeholder="请输入提现金额" class="input-price"
            @input="getPrice"></el-input>
          <div class="price-text">可提现金额为{{ max_withdraw_amount }}，</div>
          <span class="price-all" @click="selectAll">全部提现</span>
        </div>
        <div class="flex-item">
          <div class="flex-item-wrap">提现到</div>
          <div v-for="(item, index) in typeList" :key="index">
            <div class="price-div" :class="type == index ? 'price-div-active' : ''" @click="select(index)"
              v-if="item.show != 0">
              {{ item.text }}
            </div>
          </div>
        </div>
        <div class="price-number" v-if="type == 0 && isPrice">
          <div class="price-text">手续费：</div>
          <span class="price-span">￥{{ limitMessage.sxyWithdrawalFee }}</span>
          <div class="price-text">实际到账：</div>
          <span class="price-span2">￥{{ (Number(price) - 1).toFixed(2) }}</span>
        </div>
        <div class="price-list" v-if="type == 0">
          <div
            :style="activeCard == index ? 'transition: margin-top 1s;border: 1px solid #FF8622;margin-top: 10px;margin-top:-20px;' : ''"
            @click="selectCard(item.id, index)" class="list-item" :class="item.shortName"
            v-for="(item, index) in bankCardList">
            <img src="../../../assets/img/btn_selected_s.png" class="select-img" alt="" v-if="activeCard == index">
            <div class="list-item-top">
              <div class="top-left">
                <div class="top-left-div">
                  <img :src="'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/image/logo/' + item.shortName + '.png'"
                    alt="" @error="defalutErr(item)">
                </div>
                <!--              <img src="../../../assets/logo/ICBC.png" alt="">-->
                <div class="top-left-title">{{ item.bankName }}</div>
              </div>
              <div class="top-right" @click.stop="selectId(item.id)">
                <img src="../../../assets/img/bank_btn_delete.png" alt="">
              </div>
            </div>
            <div class="list-item-center">{{ item.bankCardNum }}</div>
            <div class="bankTypes">
              <span v-if="item.bankType == 0">个人</span>
              <span v-if="item.bankType == 1">企业</span>
              <span v-if="item.bankType == 2">个体户</span>
            </div>
          </div>
          <div class="list-add" @click="addCard()" :class="active ? 'list-add-active' : ''">
            <img class="list-add-icon" :src="addImage" alt="">
            <div class="list-add-text" :class="active ? 'list-add-text-active' : ''">添加银行卡</div>
          </div>
        </div>
        <div class="flex-item" v-if="type == 1">
          <div class="flex-item-wrap">收款人</div>
          <el-input v-model="name" placeholder="请输入支付宝真实姓名" class="input-price"></el-input>
        </div>
        <div class="flex-item" v-if="type == 1">
          <div class="flex-item-wrap">收款账户</div>
          <el-input v-model="number" placeholder="请输入收款账户" class="input-price"></el-input>
        </div>
        <!--        <div class="price-hint">-->
        <!--          <div class="hint-title">注意事项：</div>-->
        <!--          <div class="hint-text">1、使用银行卡提现的，提现金额{{-->
        <!--              limitMessage.bankWithdrawalFee-->
        <!--            }}元以下的需要收取{{ limitMessage.sxyWithdrawalFee }}元/笔代付费，{{-->
        <!--              limitMessage.bankWithdrawalFee-->
        <!--            }}元及以上的不收代付费，代付费用由代付公司收取。-->
        <!--          </div>-->
        <!--          <div class="hint-text">2、因财务规范调整需要，本系统于6月30日关闭支付宝和微信提现入口。您可通过绑定个人银行卡提现，请您提前做好资金安排。</div>-->
        <!--        </div>-->
        <div class="price-button" @click="confirm()">
          确定
        </div>
      </div>


      <!-- 添加银行卡 -->
      <bankAdd ref="bankAddRef" @bankAddHandel="bankAddHandel"></bankAdd>
      <!--    添加银行卡-->
      <!-- <el-dialog :title="'添加银行卡'" :visible.sync="addVisible" width="460px" :before-close="close">
        <div class="card-message">
          <div class="message-item">
            <div class="item-text">姓名</div>
            <div class="item-input">
              <input placeholder="请输入姓名" v-model="cardName" @input="getName"></input>
            </div>
          </div>
          <div class="message-item">
            <div class="item-text">银行卡号</div>
            <div class="item-input">
              <input placeholder="请输入银行卡号" v-model="cardNumber" @blur="recognitionBank"></input>
            </div>
          </div>
          <div class="message-hint">输入卡号自动识别开户行</div>
          <div class="message-item">
            <div class="item-text">开户行</div>
            <el-select class="item-select" v-model="cardType" placeholder="请选择">
              <el-option v-for="item in bankList" :key="item.id" :label="item.bankName" :value="item.bankName">
              </el-option>
            </el-select>
          </div>
          <div class="card-button">
            <div class="card-button-confirm" @click="addBankCard">确 定</div>
            <div class="card-button-cancel" @click="addCancel">取 消</div>
          </div>
        </div>
      </el-dialog> -->


      <!--    添加银行卡-->
      <el-dialog title="提示" :visible.sync="hintShow" width="460px" :before-close="closeHintShow">
        <div class="card-hint">
          <div class="card-hint-text">因财务规范调整需要，本系统于6月30日关闭支付宝和微信提现入口。您可通过绑定个人银行卡提现，请您提前做好资金安排。</div>
          <div class="card-hint-confirm" @click="hintConfirm">确 定</div>
        </div>
      </el-dialog>
      <!--    删除银行卡-->
      <el-dialog title="提示" :visible.sync="deleteHint" width="30%">
        <span>确定删除银行卡？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="deleteHint = false">取 消</el-button>
          <el-button type="primary" @click="deleteCard">确 定</el-button>
        </span>
      </el-dialog>
      <!--支付宝短信验证绑定新的账户-->
      <el-dialog title="短信验证" :visible.sync="zfbCodeHint" width="30%">
        <div class="code-center">
          <div class="title">本次提现变更支付宝，请先完成短信验证</div>
          <div class="item">
            <div class="item-text">验证码</div>
            <el-input class="code-input" v-model="codeNumber" placeholder="请输入验证码"></el-input>
            <div :class="isGetCode ? 'item-button-active' : 'item-button'" @click="getCode()">
              {{ isGetCode ? count + '秒重新获取' : '获取验证码' }}
            </div>
          </div>
        </div>
        <div class="code-button">
          <div class="code-button-confirm" @click="bindingNumber">确定</div>
          <div class="code-button-cancel" @click="zfbCodeHint = false">取消</div>
        </div>
      </el-dialog>
    </div>
    <div class="noData" v-else>
      <img src="../../../assets/img/blank_wftx.png" alt="">
      <div class="noData-text">暂时无法提现，如有疑问请联系客服</div>
    </div>
  </div>
</template>

<script>
import { getPlatformUuid } from '@/utils/auth'
import pay from '@/javaApi/pay.js'
import { alipayWithdraw } from '@/api/withdraw'
import bankAdd from '@/components/bankAdd.vue'

const payModel = new pay()
import { Icon } from 'view-design'
// 验证码弹窗
import PhoneVerification from '@/components/PhoneVerification.vue'

export default {
  name: "index",
  props: ['balance', 'official', 'max_withdraw_amount'],
  components: {
    Icon,
    PhoneVerification,
    bankAdd
  },
  data() {
    return {
      price: '',
      type: 0, // 默认银行卡提现
      // 提现类别
      typeList: [
        {
          text: '银行卡',
          show: 0
        }, {
          text: '支付宝',
          show: 0
        }
      ],
      name: '', // 收款人姓名
      number: '', // 收款人账户
      addImage: require('@/assets/img/promotion/yetx_add.png'),
      active: false, // 选择添加银行卡
      activeCard: 0, // 选择银行卡
      addVisible: false, // 添加银行卡弹窗
      cardType: '', // 开户行
      cardNumber: '',
      cardName: '',
      hintShow: false,
      details: '', // 提现数据
      // official: false, // 是否公众号点击进来的
      bankList: [], // 银行卡数组
      shortName: '', //银行卡简称
      pageNo: 1,
      pageSize: 500,
      bankCardList: [],// 我的银行卡列表
      bankCardId: '', //银行卡id
      deleteHint: false,
      limitPrice: '', //提现限制金额
      isPrice: false,
      id: '', // 选择的银行卡id
      isChangeAlipay: 0, // 是否修改了支付宝账号
      zfbCodeHint: false, //支付宝验证弹窗
      codeNumber: '', // 手机验证码
      isGetCode: false, // 是否点击获取验证码
      count: 60, // 倒计时
      timer: '',
      isClick: false,
      OldIsChangeAlipay: '', //原本的支付宝账号
      limitMessage: '', // 限制提现的信息
      noMessage: true,
      fullscreenLoading: false,
      defaultImg: 'bank_icon_mr_13',
      isAjax: false, // 请求校验
      isShow: false, // 是否显示发送验证码弹窗
      codePhone: '', //验证码
      account: '', //账户
      loadingInstance: '',
    }
  },
  mounted() {
    this.getMyBankCardList()
    this.getList()
    // 判断用户是否查看过提示
    let haveRead = localStorage.getItem('haveRead')
    if (!haveRead) {
      this.hintShow = false
    } else {
      this.hintShow = false
    }
    this.getLimit()
  },
  methods: {
    // 发送验证码弹窗-确定按钮
    AccountCenterFun(e) {

      this.codePhone = e
      console.log(e, '账户中心验证码')
      if (e.length === 0) {
        console.log(e, '验证码为空')
        this.$message.error('请输入验证码')
        return
      }
      // 支付0是银联1是支付宝
      if (this.type) {
        this.zfbWithdraw()
      } else {
        this.sxyWithdraw()
      }
    },
    // 发送验证码弹窗-关闭
    closeDialogChange(e) {
      this.isShow = false
    },
    refreshAccount() {
      // this.getDetails()
      this.$message.success('刷新成功')
    },
    // 选择提现方式
    select(index) {
      this.type = index
    },
    // 提现全部
    selectAll() {
      this.price = this.max_withdraw_amount.toString()
      this.getPrice()
    },
    // 添加银行卡
    addCard() {
      this.active = true
      this.hintShow = false
      this.addImage = require('@/assets/img/promotion/bank_btn_add_s.png')
      // this.addVisible = true
      this.$refs.bankAddRef.opens(this.bankList,'3')
    },
    // 选择银行卡
    selectCard(id, index) {
      this.id = id
      this.activeCard = index
    },
    close() {
      this.cardName = ''
      this.cardNumber = ''
      this.cardType = ''
      this.addVisible = false
    },
    getName(e) {
      console.log(e)
    },//获取提现信息
    // getDetails() {
    //   let params = {
    //     platformUuid: getPlatformUuid(),
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize
    //   }
    //   payModel.getWithdrawDetail(params).then(res => {
    //     console.log(res)
    //     if (res.data.code == 200) {
    //       this.details = res.data.data
    //       this.bankCardList = res.data.data.shoutoBankCardInfos.list
    //       this.limitPrice = res.data.data.platformBankWithdrawalFee
    //       this.name = res.data.data.name
    //       this.number = res.data.data.alipayAccount
    //       this.OldIsChangeAlipay = res.data.data.alipayAccount
    //       console.log(this.details)
    //     } else {
    //       this.$message.error(res.data.message)
    //     }
    //   })
    // },

    bankAddHandel(params,type) {
      console.log(params,type,'params,type父')
      if(type == '3') {
        let data = {
          platformUuid: getPlatformUuid(),
          ...params
        }
        console.log(data,'data')
        payModel.addBankCard(data).then(res => {
          console.log(res)
          if (res.data.code == 200) {
            this.close()
            this.$refs.bankAddRef.close()
            this.$message.success('绑定成功')
            this.getMyBankCardList()

          } else {
            this.$message.error(res.data.message)
          }
        })
      }
    },
    // 添加银行卡
    addBankCard() {

      // 处理找到对应的缩写
      for (let index in this.bankList) {
        if (this.bankList[index].bankName.indexOf(this.cardType) != -1) {
          this.shortName = this.bankList[index].shortName
          break
        }
      }
      let params = {
        platformUuid: getPlatformUuid(),
        userName: this.cardName,
        bankCardNum: this.cardNumber,
        bankName: this.cardType,
        shortName: this.shortName
      }
      payModel.addBankCard(params).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.close()
          this.$message.success('绑定成功')
          this.getMyBankCardList()

        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 获取银行卡列表
    getList() {
      let params = {
        platformUuid: getPlatformUuid(),
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      payModel.getBankCardList(params, this.official).then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.bankList = res.data.data.list
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    selectId(id) {
      this.deleteHint = true
      this.bankCardId = id
    },
    // 删除银行卡
    deleteCard() {
      let params = {
        platformUuid: getPlatformUuid(),
        id: this.bankCardId
      }
      payModel.deleteBankCard(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('删除成功')
          this.getMyBankCardList()
          this.deleteHint = false
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 价格判断是否需要手续费
    getPrice() {
      if (parseInt(this.price) < parseInt(this.limitPrice)) {
        this.isPrice = true
      } else {
        this.isPrice = false
      }
    },
    // 首信易提现
    sxyWithdraw() {
      if (this.type) {
        this.type = 0
      }
      if (this.bankCardList.length == 0) {
        this.$message.error('请先绑定银行卡')
        return
      }
      if (!this.price) {
        this.$message.error('请输入提现金额')
        return
      }
      if (!this.id) {
        this.$message.error('请选择提现到的银行卡')
        return
      }
      // 防止多次请求
      if (!this.isAjax) {
        this.isAjax = true
        let params = {
          // type:this.type,
          platformUuid: getPlatformUuid(),
          withdraw: this.price,
          bankId: this.id,
          code: this.codePhone
        }
        // this.loadingInstance  = this.starLoading('提现中');
        payModel.openSxyWithdraw(params).then(res => {
          this.isAjax = false
          console.log(res)
          // this.$nextTick(() => {
          // // 在 nextTick 之后关闭 loading
          //   this.loadingInstance.closeLoading();
          // });
          if (res.data.code == 200) {
            this.$refs.PhoneVerificationRef.setIsDisabled(true)
            this.$message.success('提现成功')
            // 关弹窗
            this.isShow = false
            this.$emit('accountIndex')
            // this.getDetails()
          } else {
            this.$message.error(res.data.message)
          }
        }).catch((err) => {
          console.log(err, 'err')
          // this.$nextTick(() => {
          // // 在 nextTick 之后关闭 loading
          //   this.loadingInstance.closeLoading();
          // });
        })
      }
    },
    // 支付宝提现
    zfbWithdraw() {
      if (!this.price) {
        this.$message.error('请输入价格')
        return
      }
      if (!this.number) {
        this.$message.error('请输入支付宝账号')
        return
      }
      console.log(this.number, 'number')
      console.log(this.OldIsChangeAlipay, 'OldIsChangeAlipay')
      if (this.number != this.OldIsChangeAlipay) {
        // this.zfbCodeHint = true
        // this.isChangeAlipay = 1
        // return
      } else {
        this.isChangeAlipay = 0
      }
      // 防止多次请求
      if (!this.isAjax) {
        this.isAjax = true
        let params = {
          money: this.price,
          alipay: this.number,
          realname: this.name,
          code: this.codePhone
        }
        // this.loadingInstance  = this.starLoading('提现中');
        alipayWithdraw(params).then(response => {
          // this.$nextTick(() => {
          // // 在 nextTick 之后关闭 loading
          //   this.loadingInstance.closeLoading();
          // });
          if (res.data.code == 200) {
            this.$refs.PhoneVerificationRef.setIsDisabled(true)
          }
          this.loading = false
          this.isAjax = false
          this.$Message.success(response.message)
          // 关弹窗
          this.isShow = false
          // this.handelCancel();
          this.$emit('accountIndex')
        }).catch(error => {
          // this.$nextTick(() => {
          // // 在 nextTick 之后关闭 loading
          //   this.loadingInstance.closeLoading();
          // });
          this.isAjax = false
          this.loading = false
          console.log(error)
        })
      }
      // let params = {
      //   code:this.codeNumber,
      //   isChangeAlipay:this.isChangeAlipay,
      //   platformUuid:getPlatformUuid(),
      //
      // }
      // payModel.zfbWithdraw(params).then(res=>{
      //   if (res.data.code == 200) {
      //     this.$message.success('提现成功')
      //     // this.getDetails()
      //   } else {
      //     this.$message.error(res.data.message)
      //   }
      // })
    },
    starLoading(text) {
      let loading = this.$loading({
        text: text, // 设置 loading 文本为 "加载中"
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector("body"),
      });
      return {
        // 方法用于关闭 loading 遮罩层
        closeLoading: () => {
          loading.close(); // 调用 loading 实例的 close 方法关闭遮罩层
        }
      }
    },
    // 提现
    confirm() {
      if (this.price <= 0) {

        this.$refs.priceNumRef.focus()
        this.$message.error('请输入提现金额')

        return
      }
      console.log(this.activeCard, this.bankCardList, '123')
      // 支付0是银联1是支付宝
      if (this.type) {
        // 支付宝
        if (this.name.length == 0 || this.number.length == 0) {
          this.$message.error('请填写收款资料')
          return
        }
        this.account = this.number
      } else {
        if (this.bankCardList.length === 0) {
          this.$message.error('请添加银行卡')
          return
        }
        // 选中银行卡号
        this.account = this.bankCardList[this.activeCard].bankCardNum
      }
      this.isShow = true
      // // 支付0是银联1是支付宝
      // if (this.type) {
      //   this.zfbWithdraw()
      // } else {
      //   this.sxyWithdraw()
      // }
    },
    // 绑定新的支付宝账号
    bindingNumber() {
      this.OldIsChangeAlipay = this.number
      this.zfbWithdraw()
      //
    },
    // 获取手机验证码
    getCode() {
      if (!this.isClick) {
        this.isClick = true // 禁止重复点击
        this.isGetCode = true // 展示已经获取验证码样式
        let params = {
          platformUuid: getPlatformUuid()
        }
        payModel.getCode(params).then(res => {
          if (res.data.code == 200) {
            this.$message.success('获取成功')
            // 倒计时
            this.timer = setInterval(() => {
              if (this.count == 0) {
                // 清除并重置
                clearInterval(this.timer)
                this.isGetCode = false
                this.isClick = false
                this.count = 60
              } else {
                this.count--
              }
            }, 1000)
          } else {
            this.$message.error(res.data.message)
          }
        })
      } else {
      }
    },
    addCancel() {
      this.close()
      this.active = false
      this.addImage = require('@/assets/img/promotion/yetx_add.png')
    },
    getMyBankCardList() {
      let params = {
        pageNo: 1,
        pageSize: 100,
      }
      payModel.getMyBankCardList(params).then(res => {
        if (res.data.code == 200) {
          console.log(res)
          this.bankCardList = res.data.data.list
          if (this.bankCardList.length > 0) {
            this.id = res.data.data.list[0].id
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 自动识别开户行
    recognitionBank() {
      let params = {
        bankCardNum: this.cardNumber
      }
      payModel.openRecognitionBank(params).then(res => {
        if (res.data.code == 200) {
          this.$message.success('识别成功')
          this.cardType = res.data.data.bank
          this.shortName = res.data.data.abbreviation
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    closeHintShow() {
      this.hintShow = false
    },
    // 已阅读提示
    hintConfirm() {
      this.hintShow = false
      localStorage.setItem('haveRead', true)
    },
    getLimit() {
      payModel.openGetLimit().then(res => {
        console.log(res)
        if (res.data.code == 200) {
          this.limitMessage = res.data.data
          this.typeList[0].show = res.data.data.sxyWithdrawSwitch
          this.typeList[1].show = res.data.data.alipayWithdrawSwitch
          if (res.data.data.sxyWithdrawSwitch == 0) {
            this.type = 1
          }
          if (res.data.data.sxyWithdrawSwitch == 0 && res.data.data.alipayWithdrawSwitch == 0) {
            this.noMessage = false
          }
        } else {
          this.$message.error(res.data.message)
        }
      })
    },
    // 图片报错时
    defalutErr(item) {
      this.$set(item, 'shortName', this.defaultImg);
    }
  }
}
</script>
<style scoped lang="less">
.bankTypes{
  color: #fff;
  font-size: 12px;
}
.price-text {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 20px;
  margin-left: 10px;
}

.price-all {
  color: rgba(61, 158, 252, 1);
  cursor: pointer;
}

.price-div {
  width: 120px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 40px;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
}

.price-div-active {
  border: 1px solid #FF8622;
  color: #FF8622;
}

.price-hint {
  margin-left: 2rem;
  margin-top: 20px;
}

.price-button {
  width: 90px;
  height: 36px;
  background: #FF8622;
  border-radius: 2px;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 36px;
  margin-left: 2rem;
  margin-top: 30px;
}

.hint-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-bottom: 10px;
}

.hint-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF4F76;
  line-height: 17px;
}

.price-number {
  display: flex;
  align-items: center;
  margin-left: 1.8rem;
  margin-top: 6px;
}

.price-span {
  color: rgba(51, 51, 51, 1);
}

.price-span2 {
  color: rgba(255, 134, 34, 1)
}

.price-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 2rem;
  margin-top: 32px;
}

.list-item {
  width: 260px;
  height: 80px;
  background: #FFFFFF linear-gradient(253deg, #3A94DB 0%, #3360D6 100%);
  border-radius: 2px;
  cursor: pointer;
  padding: 10px;
  margin-right: 25px;
  margin-top: 10px;
  position: relative;
}

.list-item-active {
  width: 260px;
  height: 80px;
  background: linear-gradient(253deg, #3A94DB 0%, #3360D6 100%);
  box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.15);
  border-radius: 2px;
  border: 1px solid #FF8622;
  transition: margin-top 1s;
  margin-top: -20px;
  cursor: pointer;
  margin-right: 25px;
  padding: 10px;
}

.list-item-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.top-left {
  display: flex;
  align-items: center;

  .top-left-div {
    width: 24px;
    height: 24px;
    background: #FFFFFF;
    border-radius: 50%;
    display: flex;
    justify-content: center;
  }

  img {
    width: 20px;
    height: 20px;
    margin: auto;
  }

  .top-left-title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 20px;
    margin-left: 10px;
  }
}

.top-right {
  img {
    width: 24px;
    height: 24px;
  }
}

.list-item-center {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 20px;
  margin-left: 34px;
  margin-top: 4px;
}

.list-add {
  width: 260px;
  height: 80px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  display: flex;
  justify-content: center;
  align-items: center;
  //margin-left: 25px;
  cursor: pointer;
  margin-top: 10px;
}

.list-add-active {
  border: 1px solid #FF8622;
}

.list-add-text-active {
  color: #FF8622 !important;
}

.list-add-icon {
  width: 24px;
  height: 24px;
}

.list-add-text {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-left: 4px;
}
</style>
<style lang="less" scoped>
.card-message {

  //padding: 20px;
  .message-item {
    display: flex;
    align-items: center;
    margin-bottom: 22px;

    .item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 20px;
      width: 60px;
      text-align: right;
      margin-right: 16px;
    }

    .item-input {
      width: 314px;
      height: 36px;
      border-radius: 2px;
      border: 1px solid #C1C1C1;

      input {
        width: 95%;
        height: 100%;
        margin-left: 10px;
      }
    }

    .item-select {
      width: 314px;
      height: 36px;
    }
  }

  .message-hint {
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #C1C1C1;
    line-height: 17px;
    margin-left: 85px;
    margin-top: -15px;
  }

  .card-button {
    display: flex;
    align-items: center;
    justify-content: center;

    .card-button-confirm {
      width: 100px;
      height: 36px;
      background: #FF8622;
      border-radius: 2px;
      text-align: center;
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 36px;
      cursor: pointer;
    }

    .card-button-cancel {
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 36px;
      text-align: center;
      width: 100px;
      height: 36px;
      background: #EEEEEE;
      border-radius: 2px;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.card-hint-text {
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 22px;
}

.card-hint-confirm {
  width: 100px;
  height: 36px;
  background: #FF8622;
  border-radius: 2px;
  text-align: center;
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 36px;
  cursor: pointer;
  margin: auto;
  margin-top: 30px;
}

.selected {
  color: #FF8622;
  background: #FCFAF8;
}

/deep/ .el-select .el-input.is-focus .el-input__inner {
  border-color: #FF8622 !important;
}

/deep/ .el-select .el-input__inner:focus {
  border-color: #FF8622 !important;
}

.item-input:hover {
  border: 1px solid #FF8622 !important;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #C1C1C1;
  line-height: 20px;
}

input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #C1C1C1;
  line-height: 20px;

}

input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #C1C1C1;
  line-height: 20px;

}

input::-ms-input-placeholder {
  /* Internet Explorer 10+ */
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #C1C1C1;
  line-height: 20px;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #EEEEEE;
}

.flex-item {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.4rem;
  width: 100%;
  min-width: 0;
  align-content: center;
  align-items: center;
}

/*提现样式*/
.input-price {
  width: 260px;
  height: 40px;
  background: #FFFFFF;
}

.price-text {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 20px;
  margin-left: 10px;
}

.price-all {
  color: rgba(61, 158, 252, 1);
  cursor: pointer;
}

.price-div {
  width: 120px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #666666;
  line-height: 40px;
  text-align: center;
  margin-right: 20px;
  cursor: pointer;
}

.price-div-active {
  border: 1px solid #FF8622;
  color: #FF8622;
}

.price-hint {
  margin-left: 2rem;
  margin-top: 20px;
}

.price-button {
  width: 90px;
  height: 36px;
  background: #FF8622;
  border-radius: 2px;
  cursor: pointer;
  text-align: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 36px;
  margin-left: 2rem;
  margin-top: 30px;
}

.hint-title {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 20px;
  margin-bottom: 10px;
}

.hint-text {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FF4F76;
  line-height: 17px;
}

.price-number {
  display: flex;
  align-items: center;
  margin-left: 1.8rem;
  margin-top: 6px;
}

.price-span {
  color: rgba(51, 51, 51, 1);
}

.price-span2 {
  color: rgba(255, 134, 34, 1)
}

.price-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 2rem;
  margin-top: 32px;
}

.flex-item-wrap {
  font-size: 14px;
  color: #666666;
  width: 1.8rem;
  margin-right: 0.2rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.money {
  font-size: 20px;
  color: #333333;
  line-height: 27px;
  display: inline-block;
  font-weight: bolder;
}

.refresh {
  margin-left: 20px;
}

.code-center {
  .title {
    font-size: 15px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 21px;
    text-align: center;
  }

  .item {
    display: flex;
    align-items: center;
    margin-top: 30px;

    .item-text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 20px;
      text-align: center;
      margin-left: 10px;
    }

    .code-input {
      width: 164px;
      height: 36px;
      background: #FFFFFF;
      border-radius: 2px;
      //border: 1px solid #C1C1C1;
      margin-left: 16px;
    }

    .item-button {
      width: 140px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #FF8622;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FF8622;
      line-height: 40px;
      margin-left: 10px;
      cursor: pointer;
    }

    .item-button-active {
      width: 140px;
      height: 40px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #C1C1C1;
      text-align: center;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 40px;
      margin-left: 10px;
    }
  }
}

.code-button {
  margin-top: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  .code-button-confirm {
    width: 100px;
    height: 36px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
    margin-right: 10px;
    cursor: pointer;
  }

  .code-button-cancel {
    width: 100px;
    height: 36px;
    background: #EEEEEE;
    border-radius: 2px;
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 36px;
    text-align: center;
  }
}

.noData {
  width: 256px;
  height: 320px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;

  img {
    width: 240px;
    height: 240px;
  }

  .noData-text {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 22px;
  }
}

.select-img {
  position: absolute;
  bottom: 0px;
  right: 0;
}

// 银行卡背景色
.CPG {
  background: linear-gradient(253deg, #35A8A6 0%, #25B47E 100%) !important;
}

.CMSB {
  background: linear-gradient(253deg, #35A8A6 0%, #25B47E 100%) !important;
}

.ABC {
  background: linear-gradient(253deg, #35A8A6 0%, #25B47E 100%) !important;
}

.BOC {
  background: linear-gradient(253deg, #F16C49 0%, #DF5056 100%) !important;
}

.ICBC {
  background: linear-gradient(253deg, #F16C49 0%, #DF5056 100%) !important;
}

.CMB {
  background: linear-gradient(253deg, #F16C49 0%, #DF5056 100%) !important;
}

.CITIC {
  background: linear-gradient(253deg, #F16C49 0%, #DF5056 100%) !important;
}

.SZD {
  background: linear-gradient(253deg, #F16C49 0%, #DF5056 100%) !important;
}

.CCB {
  background: linear-gradient(253deg, #3A94DB 0%, #3360D6 100%) !important;
}

.CIB {
  background: linear-gradient(253deg, #3A94DB 0%, #3360D6 100%) !important;
}

.BOCOM {
  background: linear-gradient(253deg, #3A94DB 0%, #3360D6 100%) !important;
}

.SPDB {
  background: linear-gradient(253deg, #3A94DB 0%, #3360D6 100%) !important;
}

.SHB {
  background: linear-gradient(253deg, #3A94DB 0%, #3360D6 100%) !important;
}

.CEB {
  background: linear-gradient(253deg, #DB9D3A 0%, #D67633 100%) !important;
}

.GDB {
  background: linear-gradient(253deg, #F16C49 0%, #DF5056 100%) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/withdraw/index.vue